const styles = {
  iconsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: "65px",
  },
  stop: {
    height: "4px",
    width: "4px",
    opacity: "0.5",
    backgroundColor: "#6373A4",
    borderRadius: "50%",
  },
  startLeft: {
    "@media screen and (max-width: 1200px)": {
      justifyContent: "flex-start !important",
    },
  },
  mobileWide: {
    "@media screen and (max-width: 1200px)": {
      position: "fixed",
      width: "100%",
    },
  },
  switchDest: {
    border: "none",
    background: "none",
    padding: "2px",
    "@media screen and (max-width: 1200px)": {
      display: "none",
    },
  },
  mainContainer: {
    margin: "0px 0 20px",
    marginLeft: "10px",
    marginRight: "10px",
    boxSizing: "border-box",
    width: "100%",
    padding: "0 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "80px",
    "@media screen and (max-width: 1200px) and (orientation: landscape)": {
      justifyContent: "flex-start",
    },
  },
  inputContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    height: "80px",
    maxWidth: "255px",
    width: "100%",
    maxHeight: "100%",
    zIndex: 1000000000,
  },
  switchButton: {
    border: "none",
    background: "none",
    padding: "2px",
  },
  switch: {
    cursor: "pointer",
    "&:active": {
      transform: "translateY(5%)",
    },
    "&:hover": {
      "& path:nth-child(2)": {
        fill: "#051D39",
      },
    },
  },
  // Portrait
  "@media (max-width: 1200px)": {
    iconsContainer: {},
    mainContainer: {
      width: "100%",
      marginTop: "20px",
    },
  },
};

export default styles;
